import { EvaluationHistory } from "@/features/oversight/governance";

export default function GovernanceEvaluationPage() {
  return <EvaluationHistory />;
}
